import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("artha_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const authApi = {
  signup: (data) => api.post("/auth/signup", data).then((r) => r.data),
  login: (data) => api.post("/auth/login", data).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  startDemo: () => api.post("/demo/start").then((r) => r.data),
};

export const PUBLIC_DOMAIN = process.env.REACT_APP_PUBLIC_DOMAIN || "https://artha.mahakalitribunal.com";
export const publicUrl = (slug) => `${PUBLIC_DOMAIN.replace(/\/$/, "")}/company/${slug}`;

export const countriesApi = {
  list: () => api.get("/countries").then((r) => r.data),
  get: (code) => api.get(`/countries/${code}`).then((r) => r.data),
};

export const entitiesApi = {
  create: (data) => api.post("/entities", data).then((r) => r.data),
  list: () => api.get("/entities").then((r) => r.data),
  get: (id) => api.get(`/entities/${id}`).then((r) => r.data),
  patch: (id, data) => api.patch(`/entities/${id}`, data).then((r) => r.data),
  tree: () => api.get("/entities-tree").then((r) => r.data),
  publish: (id) => api.post(`/entities/${id}/publish`).then((r) => r.data),
  unpublish: (id) => api.post(`/entities/${id}/unpublish`).then((r) => r.data),
};

export const publicApi = {
  company: (slug) => api.get(`/public/company/${slug}`).then((r) => r.data),
  fxRates: () => api.get("/fx/rates").then((r) => r.data),
};

export const captableApi = {
  get: (eid) => api.get(`/entities/${eid}/captable`).then((r) => r.data),
  add: (eid, data) => api.post(`/entities/${eid}/captable`, data).then((r) => r.data),
  update: (eid, sid, data) => api.patch(`/entities/${eid}/captable/${sid}`, data).then((r) => r.data),
  remove: (eid, sid) => api.delete(`/entities/${eid}/captable/${sid}`).then((r) => r.data),
  syncSri: (eid) => api.post(`/entities/${eid}/captable/sync-sri`).then((r) => r.data),
};

export const complianceApi = {
  list: () => api.get("/compliance/tasks").then((r) => r.data),
  update: (id, status) => api.patch(`/compliance/tasks/${id}`, { status }).then((r) => r.data),
};

export const docsApi = {
  upload: (file, entity_id, doc_type) => {
    const fd = new FormData();
    fd.append("file", file);
    if (entity_id) fd.append("entity_id", entity_id);
    fd.append("doc_type", doc_type || "other");
    return api.post("/documents/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  list: (entity_id) => api.get("/documents", { params: entity_id ? { entity_id } : {} }).then((r) => r.data),
  download: (id) => api.get(`/documents/${id}/download`).then((r) => r.data),
  remove: (id) => api.delete(`/documents/${id}`).then((r) => r.data),
  templates: () => api.get("/documents/templates").then((r) => r.data),
  generate: (entity_id, template_id) =>
    api.post("/documents/generate", { entity_id, template_id }).then((r) => r.data),
};

export const ecosystemApi = {
  products: () => api.get("/ecosystem/products").then((r) => r.data),
  status: () => api.get("/ecosystem/status").then((r) => r.data),
  activate: (entity_id, product_id) =>
    api.post("/ecosystem/activate", { entity_id, product_id }).then((r) => r.data),
  deactivate: (entity_id, product_id) =>
    api.post("/ecosystem/deactivate", { entity_id, product_id }).then((r) => r.data),
  events: () => api.get("/ecosystem/events").then((r) => r.data),
};

export const partnersApi = {
  list: (country) => api.get("/partners", { params: country ? { country } : {} }).then((r) => r.data),
};

export const dashboardApi = {
  overview: () => api.get("/dashboard/overview").then((r) => r.data),
};

export const paymentsApi = {
  checkout: (data) => api.post("/payments/checkout", data).then((r) => r.data),
  status: (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data),
  list: () => api.get("/payments").then((r) => r.data),
};

export const aiApi = {
  chat: (data) => api.post("/ai/chat", data).then((r) => r.data),
  sessions: () => api.get("/ai/sessions").then((r) => r.data),
  messages: (sid) => api.get(`/ai/sessions/${sid}/messages`).then((r) => r.data),
  formFill: (description) => api.post("/ai/form-fill", { description }).then((r) => r.data),
};
